import React from 'react'
import Icon from '../Common/Icon'
import DienstregelingLink from '../Dienstregeling/Link'

export default (props) => {
  const {
    route_id,
    route_long_name,
    route_short_name,
    route_text_color,
    route_color,
    date,
    time,
    directionId,
    accessibilityPrefixText,
    text,
    baseUrl
  } = props

  const style = (!route_text_color || !route_color) ? null : {
      backgroundColor: `#${route_color}`,
      color: `#${route_text_color}`,
      fill: `#${route_text_color}`
    };

  return (
    <DienstregelingLink 
      className="link--reset"
      route_id={route_id}
      route_long_name={route_long_name}
      route_short_name={route_short_name}
      date={date}
      time={time}
      directionId={directionId}
      baseUrl={baseUrl}
    >
      <span className="line-badge" style={style}>
        <Icon iconName="bus" />
        <span className="sr-only">{accessibilityPrefixText} </span>
        {text}
      </span>
    </DienstregelingLink>
  )
};


// WEBPACK FOOTER //
// ./src/components/Haltes/LineBadge.js